import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LorenUserProfileComponent} from './components/loren-user-profile/loren-user-profile.component';
import {LOREN_ROUTES} from '../../shared/constants/loren-routes.constants';

const routes: Routes = [
    {
        path: LOREN_ROUTES.PROFILE,
        component: LorenUserProfileComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenUserProfileRoutingModule {
}
